// §7.6 / D-024 — the once-per-session guest banner.
//
// The wording is PLAN-bound and lives in `copy.ts`; the two actions are the ones §7.6 names.
// It sits in the shell's own layer, not a skin's, because it says something about the *session*
// rather than about the desktop, and it has to read the same in all three skins.
import { useSyncExternalStore } from 'react';
import { COPY } from '@/copy';
import { useKernel } from '@/kernel/react';

export interface GuestBannerActions {
  /** §7.7 — "Export everything". Non-negotiable: it exists for guests too. */
  onExport: () => void;
  onSignIn: () => void;
}

export function GuestBanner({ onExport, onSignIn }: GuestBannerActions) {
  const kernel = useKernel();
  const visible = useSyncExternalStore(
    (listener) => kernel.quota.onBannerChange(listener),
    () => kernel.quota.guestBannerVisible(),
    () => false,
  );

  if (!visible) return null;

  return (
    <div className="guest-banner" role="status" data-testid="guest-banner">
      <span className="guest-banner-message" data-testid="guest-banner-message">
        {COPY.guestBanner}
      </span>
      <button type="button" data-testid="guest-banner-export" onClick={onExport}>
        {COPY.guestBannerExport}
      </button>
      <button type="button" data-testid="guest-banner-signin" onClick={onSignIn}>
        {COPY.guestBannerSignIn}
      </button>
      <button
        type="button"
        className="guest-banner-dismiss"
        aria-label="Dismiss"
        data-testid="guest-banner-dismiss"
        onClick={() => kernel.quota.dismissGuestBanner()}
      >
        ×
      </button>
    </div>
  );
}
